import { TagTypeForm } from "./TagTypeForm";

export const TagTypeEdit = () => {
    return <TagTypeForm mode="edit" />;
};
